import * as React from "react";
import C from "classnames";
import Button from "../Button";
export const Dropdown = ({ label, variant = "info", className, dropAlign = "left", ellipses, size, block, noContainer, testId, children, disabled, }) => {
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const close = () => setDropdownOpen(false);
    const ref = React.useRef();
    React.useEffect(() => {
        document.addEventListener("click", (e) => {
            if (e.target instanceof Element) {
                if (!e.target.matches(".dropdown, .dropdown *") &&
                    !e.target.matches(".dropdown-menu, .dropdown-menu .dropdown-item")) {
                    setDropdownOpen(false);
                }
            }
        });
        // close dropdown on escape
        const el = ref && ref.current;
        // tslint:disable-next-line: no-unused-expression
        el &&
            el.addEventListener("keydown", (e) => {
                if (e.isComposing) {
                    return;
                }
                if (e.key === "Escape") {
                    close();
                }
            });
    }, [ref]);
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    return noContainer ? (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: C("dropdown", block && "d-block", "dropdown-toggle", className, ellipses && "dropdown-ellipses"), variant: variant, onClick: toggle, size: size, block: block, disabled: disabled ? true : false, "data-testid": testId, ref: ref }, label),
        React.createElement("div", { className: C("dropdown-menu", "dropdown-menu-" + dropAlign, dropdownOpen ? "show" : "", block && dropdownOpen && "d-block w-100") }, React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                // @ts-expect-error
                return React.cloneElement(child, { toggle: toggle });
            }
        })))) : (React.createElement("div", { className: C("dropdown", block && "d-block"), "data-testid": testId },
        React.createElement(Button, { className: C("dropdown", block && "d-block", "dropdown-toggle", className, ellipses && "dropdown-ellipses"), variant: variant, onClick: toggle, size: size, block: block, disabled: disabled ? true : false, "data-testid": testId, ref: ref }, label),
        React.createElement("div", { className: C("dropdown-menu", "dropdown-menu-" + dropAlign, dropdownOpen ? "show" : "", block && dropdownOpen && "d-block w-100") }, React.Children.map(children, (child) => {
            if (React.isValidElement(child)) {
                // @ts-expect-error
                return React.cloneElement(child, { toggle: toggle });
            }
        }))));
};
//# sourceMappingURL=Dropdown.js.map